import { inject, injectable } from "@launchtray/tsyringe-async";
import { PlayerModel } from "../../../../common/models/PlayerModel";
import { BoosterType } from "../../../../common/models/data/BoosterType";
import { InjectableInterfaces } from "../../../../composition/InjectableInterfaces";
import { IGameDistributionSdk } from "../../../../gamedistribution/interfaces/IGameDistributionSdk";

@injectable()
export class VictoryPopupController {
    public constructor(
        private readonly playerModel: PlayerModel,
        @inject(InjectableInterfaces.IGameDistributionSdk) private readonly gdSdk: IGameDistributionSdk
    ) { }

    public purchaseBooster(type: BoosterType): boolean {
        return this.playerModel.purchaseBooster(type);
    }

    public applyCoinsAdMultiplier(initial: number, multiplier: number = 5): [number, number] {
        const result = initial * multiplier;
        const playerIncrement = initial * (multiplier - 1);
        this.playerModel.addCoins(playerIncrement);
        return [result, playerIncrement];
    }

    public async showAd(): Promise<boolean> {
        return await this.gdSdk.showRewardedAd();
    }

    public async showMidrollAd(): Promise<void> {
        return await this.gdSdk.showMidrollAd();
    }
}
